import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'

const SocialFundModal = ({ openForm }) => {
	const [updateNaz, setUpdateNaz] = useState({
		naznachenie: ''
	})

	const [modalData, setModalData] = useState([])
	const [isSave, setIsSave] = useState(false)

	const year_c = new Date().getFullYear() - 1
	const day_c = '01'
	const month_c = '09'
	const year_po = new Date().getFullYear()
	const day_po = '01'
	const month_po = '07'

	const [updateData, setUpdateData] = useState({
		data_c: `${year_c}-${month_c}-${day_c}`,
		data_po: `${year_po}-${month_po}-${day_po}`
	})
	// console.log("fgfg", updateData.data_c);
	const { t, i18n } = useTranslation()

	const change = e => {
		const { name, value } = e.target
		setUpdateNaz({ ...updateNaz, [name]: value })
		setIsSave(true)
	}

	const getReports = async id => {
		const a = await http.post('/report/reportApplicationWait?reportType=' + id)
		report.newReport(a.data.reportApplicationWait)
	}
	// console.log("student", student.student);
	// console.log("report", report.currentType);
	// console.log("report", report.reportTypes);

	React.useEffect(() => {
		getReports(0)
	}, [])
	React.useEffect(() => {
		if (openForm) {
			getModaldata()
		}
	}, [])

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		// console.log("data47545",res.data.data)
		setModalData(res.data.data)
		setUpdateNaz({ naznachenie: res.data.data.naznachenie })
		// console.log("modal", modalData);
	}

	// процедура на модального окно для сохранения данных в справках
	const updateModalDate = async () => {
		const date_c = dayjs(updateData.data_c).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_c",date_c)
		const date_po = dayjs(updateData.data_po).format('YYYY-MM-DD HH:mm:ss')
		// console.log("datepo",date_po)

		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			naznachenie: updateNaz.naznachenie,
			practice: false,
			data_c: date_c,
			data_po: date_po,
			data_c_os: null,
			data_po_os: null,
			data_c_vs: null,
			data_po_vs: null,
			data_c_practice: null,
			data_po_practice: null,
			data_c_holidays: null,
			data_po_holidays: null,
			raion_kg: null,
			work: null
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			setIsSave(false)
		}
		// console.log("update", res);
	}

	const onChangeDate = e => {
		setUpdateData({
			...updateData,
			[e.target.name]: e.target.name == '' ? e.target.checked : e.target.value
		})
		setIsSave(true)
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'

		return () => (document.body.style.overflowY = 'visible')
	}, [])

	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData?.okno_document}</label>
					<div className={styles.add_form_stud_exit}>
						{updateNaz.naznachenie?.length > 6 ?  (
							<a
								className='new_report'
								target='_blank'
								href={`/bt/api/r/s-f?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&idr=${student.student.id_raion}&idzakaz=${student.student.id_okno_zakaz}&lang=${i18n.language}`}
							>
								<button className={styles.button_modal} onClick={openForm}>
									Просмотр
								</button>
							</a>
						) : null}
					</div>
				</div>
				<div>
					<div className={styles.name_student}>
						<div className={styles.name_student_block}>
							<span className={styles.name_student_text}>Студент:</span>
							<p>{modalData?.fio}</p>
						</div>
						<div className={styles.name_student_block}>
							<span className={styles.name_student_text}>Уникальный номер справки:</span>
							<p>{modalData?.reference_number}</p>
						</div>
					</div>
					<div className={styles.modal_window_data}>
						<div className={styles.input_block}>
							<span className={styles.name_student_text}>Назначение:</span>
							<input
								className={styles.input_modal}
								type='text'
								name='naznachenie'
								value={updateNaz.naznachenie}
								onChange={change}
							></input>
						</div>
					</div>
					{/* Справка - Соц. фонд */}
					<div className={styles.modal_window_data}></div>
					<div className={styles.spravka_sos_font}>
						<div className={styles.period_txt}>Период обучения в текущем учебном году:</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Дата с:</span>
								<input
									onChange={onChangeDate}
									className={styles.input_modal}
									type='date'
									name='data_c'
									value={updateData.data_c}
								/>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Дата по:</span>
								<input
									onChange={onChangeDate}
									className={styles.input_modal}
									type='date'
									name='data_po'
									value={updateData.data_po}
								/>
							</div>
						</div>
					</div>
					<div className={styles.user}>
						<div className={styles.user_name}>
							<span className={styles.name_student_text}>Исполнитель:</span>
							<p>{modalData?.AVN_operator}</p>
						</div>
						<div className={styles.modal_footer}>
							<div></div>
							<div className={styles.footer_buttons}>
								{updateNaz.naznachenie?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SocialFundModal
